import './OrgPlansWidget.css';

import React, { useState } from 'react';
import { Box } from '@mui/material';
import usePlansData from '../../../../b2b-plans/hooks/usePlansData';
import B2BElementsExplorer from '../../../../b2b-common/B2BElementsExplorer';
import PlanCard from '../../../../b2b-plans/components/PlanCard';
import { useNavigate } from 'react-router-dom';

const OrgPlansWidget = ({ widget }) => { 

    const navigate = useNavigate();
    const [currentPage, setCurrentPage] = useState(1);
    const elementsPerPage = 4;

    const { organizationPlansData, setOrganizationPlansData, isSearching, pagesCount } = usePlansData(elementsPerPage, currentPage);

    const handleShowPlanDetails = (plan) => {
        navigate(`/plans/plans-explorer/${plan.planUUID}`);
    }

    return (
        <Box className={'OrgPlansWidget-container'}>
            <h2>{widget.widgetConfig.title}</h2>
            {organizationPlansData && organizationPlansData.content && (
                <B2BElementsExplorer
                    isSearching={isSearching}
                    elementsData={organizationPlansData}
                    pagesCount={pagesCount}
                    currentPage={currentPage}
                    handlePageChange={(event, value) => setCurrentPage(value)}
                    className={'plans-explorer'}
                    ElementComponent={PlanCard}
                    elementComponentPropName='plan'
                    otherComponentProps={{
                        showMoreButton: false,
                    }}
                    elementComponentHandlers={{
                        onAccess: handleShowPlanDetails,
                    }}
                    elementIDPropName='plan.planId'
                />
            )}            
        </Box>
    );
};

export default OrgPlansWidget;